const logger = require("services/logger");

function reportAndThrow(error) {
	logger.error(error);
	throw error;
}

function report(error) {
	logger.error(error);
}

function methodNotImplemented(name) {
	return new Error(`Method [${name}] is not implemented.`);
}

module.exports = {
	reportAndThrow,
	report,
	methodNotImplemented
};


// WEBPACK FOOTER //
// ./resources/js/helpers/errors.js